import { assetImages } from "constants";
import React from "react";
import { Link } from "react-router-dom";

import * as url from "helper/UrlHelper";

const ProfileHeader = ({
  profilePic,
  profileImageOpen,
  profileImageUploadHandler,
  profileImageRef,
  name,
  surName,
  userInfo,
  position,
  cityName,
  stateName,
  country,
  referCode,
}) => {
  return (
    <div className="account_bxitem bg_white p-4 d-flex align-items-center justify-content-between mb-4">
      <div className="personel_profile_area d-flex align-items-center gap-4">
        <div className="prsnl_profile_pic overflow-hidden rounded-circle position-relative">
          <img
            src={
              profilePic === ""
                ? assetImages.defaultUser
                : url.SERVER_URL + profilePic
            }
            className="w-100 h-100 object-fit-cover object-center"
            alt="Expert"
          />
          <div className="upload_camera">
            <Link
              to="#"
              onClick={profileImageOpen}
              id="uploadAvatar"
              className="upload_delete d-flex align-items-center justify-content-center position-relative text-white"
            >
              <span className="material-icons-outlined">photo_camera</span>
            </Link>
            <input
              onChange={profileImageUploadHandler}
              ref={profileImageRef}
              type="file"
              id="uploadprofileimage"
              className="d-none"
            />
          </div>
        </div>

        <div className="personl_profiledetails">
          <div className="profile_owner_outer d-flex mb-3 gap-2">
            <div className="profile_owner_text">
              <h4 className="text-black mb-1">
                {name} {surName}
              </h4>
              <h5 className="fs-sm text-black">{position}</h5>
              {/* <div className="edit_input input_fill">
                        <input
                          type="text"
                          value=""
                          className="form-control body_bg"
                          placeholder="Type name"
                        />
                      </div> */}
            </div>
            {/* <div className="profile_owner_editbtn mt-3">
                      <Link
                        to="#"
                        className="edit_pencil rounded-circle d-flex align-items-center justify-content-center bg-pink"
                      >
                        <span className="material-icons-outlined text-white fs-md">
                          edit
                        </span>
                      </Link>
                      <button className="edit_send rounded-circle d-flex align-items-center justify-content-center bg-pink">
                        <span className="material-icons-outlined fs-md text-white">
                          send
                        </span>
                      </button>
                    </div> */}
          </div>
          {/* {cityName === "" && stateName === "" && country === "" ? null : (
            <div className="location_tag d-inline-flex align-items-center gap-1 rounded-90 text-pink fs-sm py-2 px-3">
              <i className="material-icons-outlined fs-sm text-pink">place</i>

              <span>
                {cityName !== "" && `${cityName},`}{" "}
                {stateName !== "" && `${stateName},`} {country}
              </span>
            </div>
          )} */}
          <div className="location_tag d-inline-flex align-items-center gap-1 rounded-90 text-pink fs-sm py-2 px-3">
            <i className="material-icons-outlined fs-sm text-pink">place</i>

            <span>
              {cityName !== "" && `${cityName},`}{" "}
              {stateName !== "" && `${stateName},`} {country}
            </span>
          </div>
        </div>
      </div>
      <div className="right_profile_info">
        <label htmlFor="name" className="fw-bold mb-2 text-black fs-md">
          Refer Code :
        </label>
        {referCode === "" ? null : (
          <Link to="#" className="ms-1 btn primary-btn">
            {referCode}
          </Link>
        )}
        {/* <div className="profile_social mb-4">
          <ul className="list_style_none d-flex align-items-center justify-content-end">
            <li>
              <Link
                to="#"
                className="rounded-circle body_bg d-flex align-items-center justify-content-center"
              >
                <img src="images/fb.svg" alt="" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="rounded-circle body_bg d-flex align-items-center justify-content-center"
              >
                <img src="images/gmail.svg" alt="" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="rounded-circle body_bg d-flex align-items-center justify-content-center"
              >
                <img src="images/linkedin.svg" alt="" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="rounded-circle body_bg d-flex align-items-center justify-content-center"
              >
                <img src="images/pinterest.svg" alt="" />
              </Link>
            </li>
          </ul>
        </div> */}
        {/* <div className="profile_links">
                  <ul className="list_style_none d-flex flex-wrap gap-2">
                    <li>
                      <Link
                        to="#"
                        className="rounded-90 body_bg px-3 py-2 text-primary-gray fw-medium fs-sm"
                      >
                        UX Design
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="rounded-90 body_bg px-3 py-2 text-primary-gray fw-medium fs-sm"
                      >
                        Working Day
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="rounded-90 body_bg px-3 py-2 text-primary-gray fw-medium fs-sm"
                      >
                        Latest Trends
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="rounded-90 body_bg px-3 py-2 text-primary-gray fw-medium fs-sm"
                      >
                        08+
                      </Link>
                    </li>
                  </ul>
                </div> */}
      </div>
    </div>
  );
};

export default ProfileHeader;
